
export function navigatorGo(path: string) {
  // console.log('Will go to path:', path);
  setTimeout(() => {
    // console.log('Going to path:', path);
    window.location.href = path;
  }, 250);
}
